import React from "react";
import { Outlet } from "react-router-dom";
import "./meta-ads-ordering.css";

const MetaAdsLayout = () => {
  return (
    <div className="ordering-meta-ads-surface relative min-h-[60vh]">
      <Outlet />
    </div>
  );
};

export default MetaAdsLayout;
